import * as React from 'react';
// @ts-expect-error [MIGRATION-SUPPRESSION]: TS1484
import { IntlProvider, IntlShape } from 'react-intl';
import intlHelper, { loadLanguageBundle } from '../lib/intl';

type Props = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  intl?: IntlShape; // Must include all needed messages if passed in by a consumer,
  language: string; // Usually comes from the current user
};

function Internationalize({
  children,
  fallback = <div />,
  intl,
  language,
}: Props) {
  const intlInstance = intl || intlHelper;
  const [isLoaded, setIsLoaded] = React.useState(!!intl);

  React.useEffect(() => {
    if (!!intl || !language) return;

    setIsLoaded(false);

    loadLanguageBundle(language).then(() => {
      setIsLoaded(true);
    });
  }, [intl, language]);

  if (!language || !isLoaded) {
    return fallback;
  }

  return (
    <IntlProvider
      locale={intlInstance.locale}
      messages={intlInstance.messages}
      textComponent="span"
    >
      {children}
    </IntlProvider>
  );
}

export default Internationalize;
